import React, { useState, useEffect } from "react";
import { Progress, Button } from "antd";
import {
  HomeOutlined,
  LoadingOutlined,
  SettingFilled,
  SmileOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import TextArea from "antd/es/input/TextArea";

export const ProgressComp = ({ status, isPending }) => {
  const [reading, setReading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [progressStatus, setProgressStatus] = useState(null);
  const [progressVisible, setProgressVisible] = useState(false);

  useEffect(() => {
    if (isPending && (status === 0 || !status)) {
      //console.log("XXX ProgressComp",isPending);
      if (isPending) {
        setProgressStatus(null);
        setProgress(0);
        setReading(true);
        setProgressVisible(true);
      } else {
        setProgress(100);
      }
    }
  }, [isPending]);
  useEffect(() => {
    switch (status) {
      case 1: {
        //console.log("XXX ProgressComp Start");
        setProgressStatus(null);
        setProgress(0);
        setReading(true);
        setProgressVisible(true);
        break;
      }
      case 2: {
        setProgressStatus("exception");
        setProgress(100);
        setReading(true);
        setProgressVisible(true);
        break;
      }
      default: {
        setProgress(100);
        //console.log("XXX ProgressComp Ende");
      }
    }
  }, [status]);

  /*
  useEffect(() => {
    setProgress(0);
    setReading(true);
    setProgressVisible(true);
  }, []);
*/
  useEffect(() => {
    let interval;

    if (reading) {
      interval = setInterval(() => {
        setProgress((prevProgress) => {
          const newProgress = prevProgress + 3;
          if (newProgress >= 100) {
            clearInterval(interval);
            setReading(false);
            return 100;
          }
          return newProgress;
        });
      }, 50); // Ändern Sie die Häufigkeit, je nachdem wie schnell sich der Fortschritt ändern soll
    } else {
      clearInterval(interval);
    }

    return () => clearInterval(interval);
  }, [reading]);

  useEffect(() => {
    // Überwachen Sie den Zeitpunkt, wenn der Fortschrittsbalken 100% erreicht hat
    if (progress === 100) {
      const timeout = setTimeout(() => {
        setProgressVisible(progressStatus !== null); // Bei Error bleibt es ewig
      }, 800); // Zeit bei 100%
      return () => clearTimeout(timeout);
    }
  }, [progress]);

  return (
    <>
      {progressVisible && (
        <div className="overlay-center">
          <Progress
            type="circle"
            percent={progress}
            size=""
            status={progressStatus}
          />
        </div>
      )}
    </>
  );
};

export const PendingComp = ({ isPending }) => {
  return (
    <>
      {isPending && (
        <div className="overlay-center">
          <div
            style={{
              width: 100,
              height: 100,
              background: "rgba(211,211,211,0.2)", // Hintergrundfarbe mit 20% Transparenz
              borderRadius: "50%", // Runder Hintergrund
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            <LoadingOutlined style={{ fontSize: 64}} />
          </div>
        </div>
      )}
    </>
  );
};

export const PendingCompTimeout = ({ isPending }) => {
  const [showOverlay, setShowOverlay] = useState(false);

  useEffect(() => {
    let timeoutId;
    if (isPending) {
      // Anzeigen des Overlays und Planen zum Ausblenden nach 300 ms
      setShowOverlay(true);
      timeoutId = setTimeout(() => {
        setShowOverlay(false);
      }, 1000);
    } else {
      // Sofortiges Ausblenden des Overlays, wenn isPending false ist
      //setShowOverlay(false);
    }

    return () => {
      // Aufräumen des Timers beim Unmount der Komponente oder bei Änderung von isPending
      //setShowOverlay(false);
      //clearTimeout(timeoutId);
    };
  }, [isPending]);

  return (
    <>
      {showOverlay && (
        <div className="overlay-center">
          <div
            style={{
              width: 100,
              height: 100,
              background: "rgba(211,211,211,0.2)", // Hintergrundfarbe mit 20% Transparenz
              borderRadius: "50%", // Runder Hintergrund
              display: "flex",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            <LoadingOutlined style={{ fontSize: 64}} />
          </div>
        </div>
      )}
    </>
  );
};

